import { Text, type ElementProps, type TextProps } from "@mantine/core";

type FeedbackLineProps = TextProps & ElementProps<"div", keyof TextProps>;

/** One reserved text line; longer feedback remains free to wrap. */
export function FeedbackLine({ children, style, ...props }: FeedbackLineProps) {
  return (
    <Text
      component="div"
      size="sm"
      c="danger"
      {...props}
      style={[{ minHeight: "1lh", minWidth: 0, flexShrink: 0, overflowWrap: "anywhere" }, style]}
    >
      {children}
    </Text>
  );
}
